import React from 'react';
import { HomeMenuCategoryWithFoods } from '../../../../../interfaces/types';

interface CategoryTabsProps {
  categories: HomeMenuCategoryWithFoods[];
  activeCategoryId: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({ categories, activeCategoryId, onCategoryChange }) => {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-3 px-4">
      {categories.map((category) => {
        const enabled = category.id === activeCategoryId;
        return (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`w-fit py-2 px-3 text-sm font-semibold leading-5 whitespace-nowrap rounded-md ${enabled ? 'bg-[#3D9F4A] text-white' : 'bg-gray-100 text-gray-600'
              }`}
          >
            {category.title}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryTabs;
